function init() {

	const videoBannerEls = document.querySelectorAll('.banner.has--video');

	if (!videoBannerEls.length || !(window.VTTCue || window.TextTrackCue)) {
		return;
	}

	[...videoBannerEls].forEach((bannerEl) => {

		const videoEl = bannerEl.querySelector('video');
		let endingTimer;

		if (videoEl.readyState > 0) {
			// Add cues right away if 'loadedmetadata' has already triggered
			addCues(bannerEl, videoEl);
		} else {
			videoEl.addEventListener('loadedmetadata', () => {
				addCues(bannerEl, videoEl);
			});
		}

		videoEl.addEventListener('ended', () => {
			endingTimer = window.setTimeout(() => {
				videoEl.currentTime = 0;
				videoEl.play();
			}, 7000);
		});

		videoEl.addEventListener('seeking', () => {
			window.clearTimeout(endingTimer);
		});

	});


}

// @link https://iandevlin.com/blog/2015/02/javascript/dynamically-adding-text-tracks-to-html5-video/
function addCues(bannerEl, videoEl) {

	const track = videoEl.addTextTrack('captions', 'English', 'en');
	// Test if VTTCue exists. IE uses similar TextTrackCue instead.
	const Cue = window.VTTCue || window.TextTrackCue;

	track.mode = 'hidden';

	try {

		track.addCue(new Cue(12, 20, 'holiday-greeting'));

		track.addEventListener('cuechange', (cueEvent) => {

			[...cueEvent.currentTarget.cues].forEach((cue) => {
				bannerEl.classList.remove(`cue--${cue.text}`);
			});

			[...cueEvent.currentTarget.activeCues].forEach((cue) => {
				bannerEl.classList.add(`cue--${cue.text}`);
			});

		});

	} catch (error) { }

}

export default {
	init
};
